import { z } from 'zod';

const EnvSchema = z.object({
  VITE_APP_ENV: z.enum(['dev', 'staging', 'prod', 'test']),
  VITE_APP_NAME: z.string().min(1),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_DEV_PORT: z.string().optional(),
  VITE_ROUTER_BASENAME: z.string().min(1).regex(/^\//, 'must start with "/"'),
});

export type AppEnv = z.infer<typeof EnvSchema>;

const parsed = EnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('[env] invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables. See console for details.');
}

export const env: AppEnv = parsed.data;

export const isDev = env.VITE_APP_ENV === 'dev';
export const isStaging = env.VITE_APP_ENV === 'staging';
export const isProd = env.VITE_APP_ENV === 'prod';
